import { useEffect, useState } from 'react';
import { Badge, Button, ButtonGroup, Dropdown, Modal } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';
import { TbTrash, TbTrashOff } from 'react-icons/tb';
import {
    assignVoucher,
    deleteUsers,
    deleteVoucher,
    getTransactions,
    getUserWithdrawableTransactions,
    getUsers,
    notAssignedVoucher,
} from '../../../Services/AdminServices/adminUserServices';
import UserTransaction from './UserTransaction';
import UserWithdrawableTransaction from './UserWithdrawableTransaction';
import DataTables from '../../Main/DataTable/DataTables';
import toast from 'react-hot-toast';
import { ImCross } from 'react-icons/im';

const Users = () => {
    const [tab, setTab] = useState("transaction");
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [userTransaction, setUserTransaction] = useState([]);
    const [withdrawableTransaction, setWithdrawableTransaction] = useState([]);
    const [voucherList, setVoucherList] = useState([]);
    const [lgShow, setLgShow] = useState(false);
    const [userId, setUserId] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const handleStartDate = (e) => setStartDate(e.target.value);
    const handleEndDate = (e) => setEndDate(e.target.value);



    const columns = [
        {
            name: 'S.No.',
            selector: (row, index) => index + 1,
            width: '80px',
        },
        { name: 'Name', selector: row => row.name },
        { name: 'Email', selector: row => row.email, width: '250px', },
        { name: 'Referral Code', selector: row => row.referral_code, width: '250px' },
        { name: 'Wallet Balance', selector: row => row.wallet_balance },
        {
            name: 'Assign Voucher',
            cell: row => {
                if (row?.assigned_voucher === "No voucher assigned") {
                    return (

                        <>
                            <Dropdown>
                                <Dropdown.Toggle
                                    variant="success"
                                    size="sm"
                                    id={`dropdown-${row.id}`}
                                    // style={}
                                    className='s-12'
                                >
                                    {row?.assigned_voucher}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {Array.isArray(voucherList) && voucherList.length > 0 ? (
                                        voucherList.map((item, i) => (
                                            <Dropdown.Item key={i} onClick={() => handleAssignVoucher(row?.id, item?.id)}>
                                                {item?.title}
                                            </Dropdown.Item>
                                        ))
                                    ) : (
                                        <Dropdown.Item disabled>No Vouchers</Dropdown.Item>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>
                        </>
                    );
                } else {
                    return (
                        <>
                            <span class="badge bg-success badge-success s-16 py-2">{row?.assigned_voucher.substring(0, 15) + "..."}
                                <ImCross size={12} onClick={() => { handleDeteVoucher(row?.assigned_voucher_id) }} className='ms-3 cursor-pointer' color='white' />
                            </span>


                        </>
                    )
                }
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '250px',
        },
        {
            name: 'Status',
            cell: row => {
                const status = row?.status?.toLowerCase();
                const statusColors = {
                    active: 'primary',
                    inactive: 'secondary',
                    banned: 'danger',
                };
                const badgeColor = statusColors[status] || 'primary';
                return <Badge bg={badgeColor} className="text-capitalize">{row.status}</Badge>;
            },
            width: '80px',

        },
        {
            name: 'Action',
            width: '200px',
            cell: row => (
                <>
                    <FaEye size={16} onClick={() => handleShow(row?.id)} style={{ cursor: "pointer" }} />
                    {row?.role !== "admin" ? (
                        <TbTrash className='ms-3' onClick={() => handleDelete(row?.id)} style={{ cursor: "pointer" }} size={16} />
                    ) : (
                        <TbTrashOff className='ms-3' style={{ cursor: "not-allowed" }} size={16} />
                    )}
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const getAllUsers = async () => {
        setIsLoading(true);
        const response = await getUsers();
        if (response.code === 200) {
            setData(response?.result?.users?.original?.data);
        }
        setIsLoading(false);
    };

    const getNotAssignedVoucher = async () => {
        setIsLoading(true);
        const response = await notAssignedVoucher();
        if (response.code === 200) {
            setVoucherList(response?.result?.data);
        }
        setIsLoading(false);
    };

    const getUserTransactions = async (id) => {
        setIsLoading(true);
        const response = await getTransactions(id, startDate, endDate);
        if (response.code === 200) {
            setUserTransaction(response?.result?.transactions?.data);
        }
        setIsLoading(false);
    };

    const getWithdrawableTransactions = async (id) => {
        setIsLoading(true);
        const response = await getUserWithdrawableTransactions(id, startDate, endDate);
        if (response.code === 200) {
            setWithdrawableTransaction(response?.result?.data?.original?.data);
        }
        setIsLoading(false);
    };

    const handleDelete = async (id) => {
        setIsLoading(true);
        const response = await deleteUsers(id);
        if (response.code === 200) {
            getAllUsers();
        }
        setIsLoading(false);
    };

    const handleShow = (id) => {
        setUserId(id);
        setLgShow(true);
        getUserTransactions(id);
        getWithdrawableTransactions(id);
    };

    useEffect(() => { getAllUsers(); }, []);
    useEffect(() => { getNotAssignedVoucher(); }, []);
    useEffect(() => {
        if (userId) {
            getUserTransactions(userId);
            getWithdrawableTransactions(userId);
        }
    }, [userId, startDate, endDate]);

    const handleAssignVoucher = async (userId, voucherId) => {
        setIsLoading(true);
        try {
            const response = await assignVoucher(voucherId, userId);
            if (response.code === 201) {
                getAllUsers(); // refresh data
                getNotAssignedVoucher();
                toast.success(response?.message)
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDeteVoucher = async (voucherId) => {
        setIsLoading(true)
        let response = await deleteVoucher(voucherId);
        if (response?.code === 200 || response?.code === 201) {
            setIsLoading(false)
            getAllUsers();
            getNotAssignedVoucher();
            toast.success(response?.message)
        }
        else {
            setIsLoading(false)
            toast.success(response?.message)
        }


    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className='fw-bold mb-0'>User Management</h3>
                        <p className='text-muted'>View and manage all registered users</p>
                    </div>

                    {isLoading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <DataTables filter={true} columns={columns} data={data} />
                    )}
                </div>
            </div>

            <Modal size="lg" show={lgShow} onHide={() => setLgShow(false)} aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Account Detail
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-lg-12 mt-4">
                        <div className='p-1 bg-light shadow-sm rounded'>
                            <ButtonGroup className='w-100'>
                                <Button onClick={() => setTab("transaction")} variant={tab === "transaction" ? "primary" : ""}>Transaction</Button>
                                <Button onClick={() => setTab("withdrawableTransaction")} variant={tab === "withdrawableTransaction" ? "primary" : ""}>Withdrawal Requests</Button>
                            </ButtonGroup>
                        </div>
                    </div>

                    <div className="col-lg-12 mt-3">
                        {(tab === "transaction" || tab === "withdrawableTransaction") && (
                            <div className="row justify-content-end">
                                <div className="col-auto">
                                    <label className='fw-bold s-12'>Start Date</label>
                                    <input value={startDate} onChange={handleStartDate} type="date" className='form-control' />
                                </div>
                                <div className="col-auto">
                                    <label className='fw-bold s-12'>End Date</label>
                                    <input value={endDate} onChange={handleEndDate} type="date" className='form-control' />
                                </div>
                            </div>
                        )}

                        {tab === "transaction" && (
                            <UserTransaction userTransaction={userTransaction} />
                        )}
                        {tab === "withdrawableTransaction" && (
                            <UserWithdrawableTransaction withdrawableTransaction={withdrawableTransaction} />
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Users;
